import { ShieldCheck, ShieldAlert } from "lucide-react";

const when = (iso) => (iso ? new Date(iso).toLocaleString() : "—");

/* THE BEFORE-AND-AFTER ACCESS CHECK: every start compares every person's access with what the previous build left. */
export function AccessCheckNote({ check }) {
  const last = check?.last;
  if (!last) return <p data-testid="access-check-none" className="text-xs text-slate-500">No startup access check recorded yet.</p>;
  const ok = last.identical && !check.starts_changed;
  const Icon = ok ? ShieldCheck : ShieldAlert;
  return (
    <div data-testid="access-check" className={`rounded-lg border p-3 flex gap-2 text-sm ${ok ? "border-emerald-200 bg-emerald-50/60" : "border-red-200 bg-red-50"}`}>
      <Icon className={`w-5 h-5 shrink-0 ${ok ? "text-emerald-700" : "text-red-700"}`} />
      <div>
        <p data-testid="access-check-last">
          <b>Access check at the last start ({when(last.at)}):</b>{" "}
          {last.identical
            ? <>all {last.people} accounts have exactly the access they had before it.</>
            : <span className="text-red-700 font-semibold">{last.changed} of {last.people} accounts changed.</span>}
        </p>
        <p data-testid="access-check-since" className="text-[12px] text-slate-600">
          Checked at {check.starts} start{check.starts === 1 ? "" : "s"} since {when(check.first?.at)} ·{" "}
          {check.starts_changed ? <span className="text-red-700 font-semibold">{check.starts_changed} found a change</span> : "none found a change"}.
          Roles, renames and retirements never change access; only your toggles and each person's exceptions do.
        </p>
      </div>
    </div>
  );
}
